export default class Menu {
  constructor(id) {
    this.mainMenu = document.getElementById(id);

    // If there is no menu, return
    if (this.mainMenu == null) return;

    this.menuItems = document.querySelectorAll('[data-menu-id]');
    this.toggleMobile = document.getElementById('toggleMobileMenu');
    this.subMenus = document.querySelectorAll('.submenu');

    // This is only for xl and up
    // @TODO: add a pasive event that rechecks this
    if (document.body.clientWidth >= 1280) {
      this.subMenus.forEach((element) => {
        element.addEventListener('mouseleave', () => {
          element.classList.add('hidden');
        })
      })
    }

    // Attach event listeners
    this.toggleMobile.addEventListener('click', this.mobileToggle.bind(null, event, this.mainMenu, this.toggleMobile), false);
    this.menuItems.forEach((element) => {
      element.addEventListener('click', this.menuItemClick.bind(null, event, element), false)

      // Desktop, this should be available only on 1280+
      // @TODO: On screen resize recheck this.
      if (document.body.clientWidth >= 1280) {
        element.addEventListener('mouseover', this.mouseOver.bind(null, event, element), false)
      }
    })
  }

  mouseOver(event, element) {
    let menuId = element.getAttribute('data-menu-id');
    let subMenu = document.getElementById(menuId);

    let openSubMenus = document.querySelectorAll('.submenu:not(.hidden)');
    openSubMenus.forEach((menuElement) => {
      menuElement.classList.add('hidden');
    })

    // mainMenu.classList.add('hidden');

    if (subMenu !== null) {
      subMenu.classList.remove('hidden');
    }
  }

  menuItemClick(event, element) {
    event.preventDefault();

    let subMenuId = element.getAttribute('data-menu-id');
    let subMenu = document.getElementById(menuId);

    let openSubMenus = document.querySelectorAll('.submenu:not(.hidden)');
    openSubMenus.forEach((menuElement) => {
      menuElement.classList.add('hidden');
    })

    this.mainMenu.classList.add('hidden');

    if (subMenu !== null) {
      subMenu.classList.remove('hidden');
    }
  }

  mobileToggle(event, mainMenu, toggleMobile) {
    console.log("toggle mobile")
    const html = document.querySelector('html');

    // Hide all submenus that do not have the class hidden
    const subMenusShown = document.querySelectorAll('.submenu:not(.hidden)');

    subMenusShown.forEach((element) => {
      element.classList.add('hidden');
    })

    // If the menu is already open, close everything
    // Else we open the menu
    if (toggleMobile.classList.contains('open')) {
      html.classList.remove('overflow-hidden');
      mainMenu.classList.add('hidden');
    } else {
      html.classList.add('overflow-hidden');
      mainMenu.classList.remove('hidden');
    }
    toggleMobile.classList.toggle('open');
  }
}

// window.addEventListener('resize', function () {
//   // recheck for submenus
// }, {
//   passive: true
// });
